<script setup>
const props = defineProps({
    shadowContentBoxConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator(rawValue) {
            const validations = {
                type: rawValue => rawValue.type === undefined || typeof rawValue.type === 'string',
                opacity: rawValue => rawValue.opacity === undefined || typeof rawValue.opacity === 'boolean',
                placeholder: rawValue => rawValue.placeholder === undefined || typeof rawValue.placeholder === 'boolean',
                selected: rawValue => rawValue.selected === undefined || typeof rawValue.selected === 'boolean'
            }

            return Object.values(validations).every(validate => validate(rawValue))
        }
    }
})

// Get shadow box class
const getShadowBoxClass = computed(() => {
    return {
        'selected': !props.shadowContentBoxConfig?.placeholder && props.shadowContentBoxConfig?.selected,
        'skeleton-placeholder-container': props.shadowContentBoxConfig?.placeholder
    }
})

const component = computed(() => props.shadowContentBoxConfig?.type ? props.shadowContentBoxConfig.type : 'li')
</script>

<template>
    <component :is="component" class="shadow-content-box" :class="getShadowBoxClass">
        <slot />
    </component>
</template>

<style lang="scss">
.shadow-content-box {
    width: 100%;
    background: $shadow-content-box-bg;
    color: $shadow-content-box;
    border-radius: 20px;
    cursor: pointer;
    transition: box-shadow 400ms ease;

    .center-selector-teaser-container & {
        background: $shadow-content-box-transparent-bg;
        border-radius: 16px; // redesign (CN-12074): Figma field radius (was 20px)
        backdrop-filter: blur(10px); // redesign (CN-12074): frosted field over the teal band

        &.selected,
        &:hover {
            box-shadow: none; // redesign (CN-12074): no purple hover shadow on the center selector
        }
    }

    &.selected,
    &:hover {
        box-shadow: 4px 4px 5px $shadow-content-box-shadow1, 2.5px 2.5px 0 $shadow-content-box-shadow2;
    }
}
</style>
